/*
 * Copyright (C) 2025 - present by Potentially
 *
 * Please see distribution for license.
 */

import { Component, OnInit, inject } from '@angular/core';
import { MEMBER_SORT_KEYS } from '@app/app/page-modules/admin/components/members/admin-member-list/v3-admin-member-list/v3-admin-member-list.component';
import { AdminMembersComponent } from '@app/app/page-modules/admin/components/members/members.component';
import { MembersSearchOrder } from '@app/app/shared/models/admin/members.model';
import { TableUrlStateService } from '@app/app/shared/services/table-url-state/table-url-state.service';
import { DEFAULT_PAGE_SIZE } from '@app/app/shared/styleguide/components/pagination/pagination-footer.component';

const DEFAULT_SORT_FIELD = 'lastActiveOn';
const DEFAULT_SORT_DIRECTION = 'DESC';

@Component({
  selector: 'ptl-v3-admin-members',
  templateUrl: './v3-members.component.html',
  styleUrls: ['./v3-members.component.scss'],
})
export class V3AdminMembersComponent extends AdminMembersComponent implements OnInit {
  private urlState = inject(TableUrlStateService);
  private urlStateReady = false;

  private get ownsUrlState(): boolean {
    return !this.isCardPage && !this.isPlaylistPage;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.restoreUrlState();
  }

  override changeListOrderingByBooleanFilter(
    update: { order: MembersSearchOrder; page: number; pageSize: number },
    allMembers = false,
  ): void {
    super.changeListOrderingByBooleanFilter(update, allMembers);
    this.syncUrl();
  }

  private restoreUrlState(): void {
    if (!this.ownsUrlState) {
      return;
    }

    this.page = this.urlState.pageIndex();
    this.pageSize = this.urlState.pageSize();

    const sortField = this.urlState.option<string>('sort', MEMBER_SORT_KEYS);
    if (sortField) {
      this.order = {
        fieldName: sortField,
        direction: this.urlState.string('dir') === 'desc' ? 'DESC' : 'ASC',
      };
    }

    this.urlStateReady = true;
    this.syncUrl();
  }

  private syncUrl(): void {
    if (!this.ownsUrlState || !this.urlStateReady) {
      return;
    }

    const isDefaultSort = this.order?.fieldName === DEFAULT_SORT_FIELD && this.order?.direction === DEFAULT_SORT_DIRECTION;
    this.urlState.patch({
      page: this.page > 0 ? this.page + 1 : null,
      size: this.pageSize === DEFAULT_PAGE_SIZE ? null : this.pageSize,
      sort: isDefaultSort ? null : this.order?.fieldName,
      dir: !isDefaultSort && this.order?.direction === 'DESC' ? 'desc' : null,
    });
  }
}
